import React, { Component } from 'react'
import { connect } from 'react-redux';

import classnames from "classnames";
import Button from './../shared/Button/index';

import styles from './../../styles/perfect_essay.styl';
import baseStyles from 'custom/base.styl';

import success from './../../img/success@3x.png';
import graph from './../../img/graph.png';

import { profileUpdateStages } from "../../store/profile/actions";

class EssayLinearRegression extends Component {
  constructor(props) {
    super(props)

    this.state = {
      curStep: 'step1',
    }

    this.onStepClick = this.onStepClick.bind(this)
    this.onComplete = this.onComplete.bind(this)
    this.onStageNext = this.onStageNext.bind(this)
  }

  onStepClick(e) {
    const newStep = e.target.dataset.step;
    // let offsetTop  = e.target.getBoundingClientRect().top;

    this.setState({
      curStep: newStep,
    });
    // e.target.scrollIntoView({ behavior: "smooth" });
    const el = document.getElementById(newStep);
    el.scrollIntoView({ behavior: "smooth" });


    // this.setState({
    //   curStep: newStep,
    // }, () => window.scrollTo({ top: offsetTop, behavior: 'smooth' }));
  }

  onComplete() {
    this.setState({
      curStep: 'finish',
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onStageNext() {
    const { nextStage } = this.props;
    nextStage();
    return;
  }

  render() {
    const { curStep } = this.state;

    return (
      <div>
        {/* page-1 */}
        <div className={classnames(styles.perfect_essay)}>

          <div className={classnames(styles.comment_finish, { [styles.active]: curStep === 'finish' })}>
            <img src={success} alt="success" width="100px" />
            <h3>Thank you for completing <br /> the first essay</h3>
						<p>There’s only one test essay left <br /> before you join us as a writer and <br /> start working with real orders. <br /> Show there all your academic <br /> knowledge and writing skills, as we <br /> will check it thoroughly to decide <br /> whether you have passed the <br /> probation.</p>
            <Button onClick={(e) => this.onStageNext(e)} block >Begin the last essay</Button>
          </div>

          <div className={styles.catchword}>Student’s Last Name 1</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step1' })} data-step="step1" id="step1">

            <div className={styles.highlighting_content}>
              <header>
                TO: Professor’s Name <br />
                FROM: Student’s Name<br />
                DATE: DD MM YYYY<br />
                SUBJECT: Regression Analysis<br />
              </header>

              <div className={styles.center}>Linear Regression</div>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The paper follows the requirements of the MLA formatting style.</li>
                  <li>No personal information is included.</li>
                  <li>Please download a template to avoid mistakes and spend less time on formatting.</li>
                </ul>
                <div className={classnames(styles.btn_wrap, baseStyles.flex_right)}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">NEXT&rarr;&nbsp;</button>
                </div>
              </div>

            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step2' })} data-step="step2" id="step2">
            <div className={styles.highlighting_content}>
              <p>Occupational Prestige Score is the numerical variable of interest in this short study. Socio Economic Index of Individual is a numerical variable that represents one’s income, education and occupation, as such it has a strong impact on the Occupational Prestige Score, hence, will be considered the independent variable in the analysis. Linear regression is one of the simplest and most commonly used models that show the linear relationship between the dependent and independent variables.</p>

              <div className={styles.comment}>
                <ul>
                  <li>The instructions are followed: the paper is written in a form of a Memo and contains all of the required elements. </li>
                  <li>The word count requirement is met.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step1">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <p><b>Regression analysis</b></p>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step3' })} data-step="step3" id="step3">
            <div className={styles.highlighting_content}>
              <p>As mentioned above, Socio-Economic Index of Individual is the independent variable X that is used to predict the dependent variable Y, Occupational Prestige Score. The equation of the linear regression has the form Y = bx + a, where b is the slope of the regression line and a is the intercept. An analysis of the data showed that the equation for this case is y = 1.2271x - 4.3667 (Pic.1). It means that with each change of the Socio-Economic Index of Individual by 1 point, Occupational Prestige Score will increase on 1.2271. Also, if the variable X is equal to zero, then the variable Y will be -4.3667</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph is devoted to one idea that is presented in the topic sentence.</li>
                  <li>Language: No personal pronouns, phrasal verbs, contractions, idioms, colloquial language, rhetorical questions are used.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* page-2 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword}>Student’s Last Name 2</div>

          <div className={styles.center}>
            <img src={graph} alt="graph" width="462px" />
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type4, { [styles.active]: curStep === 'step4' })} data-step="step4" id="step4">
            <div className={styles.highlighting_content}>
              <p>Pic.1 Scatter Plot that shows the dependence between Socio-Economic Index of Individual and Occupational Prestige Score</p>
              <div className={styles.comment}>
                <p>The requirement to “Include all appropriate Excel printouts, tables and charts into the memo” is followed.</p>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step5' })} data-step="step5" id="step5">
            <div className={styles.highlighting_content}>
              <p><b>Coefficients of Determination and Correlation</b></p>
              <p>As shown in the Pic. 1, the coefficient of determination, R<sup>2</sup> is equal 0.7631. It means that 76.31% of the changes in Occupational Prestige Score can be explained by the changes in Socio-Economic Index of Individual. The numerical value of the coefficient is quite large and it means that the linear regression model is accurate. The coefficient of correlation R is measured as a root square of the coefficient of determination and is equal to 0.8736. This coefficient is high and it can be said that there is a strong linear relationship between Socio-Economic Index of Individual and Occupational Prestige Score. </p>
              <div className={classnames(styles.comment, styles.comment_bottom)}>
                <ul>
                  <li>Structure: The paragraph contains at least 3 sentences and does not exceed 200 words. It begins with a linking word that contributes to the logical flow of the essay.</li>
                  <li>Proofreading: No repetitions, misprints, punctuation issues are present in the paper.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step6">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step6' })} data-step="step6" id="step6">

            <div className={styles.highlighting_content}>

              <p>In conclusion, the regression analysis showed that there is a strong positive linear relationship between Socio-Economic Index of Individual and Occupational Prestige Score. Therefore, the independent variable Socio-Economic Index of Individual can be used to predict the value of the Occupational Prestige Score.</p>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>Content: The Conclusion contains no new information and summarizes the key points reflected in the body of the paper.</li>
                  <li>As per the instructions, no Works Cited page is included.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">&larr;&nbsp;PREVIOUS</button>
                  <Button onClick={(e) => this.onComplete(e)} className={styles.btn_finish} light>Finish</Button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  nextStage: () => dispatch(profileUpdateStages()),
});

export default connect(null, mapDispatchToProps)(EssayLinearRegression);




// WEBPACK FOOTER //
// ./src/components/PerfectEssay/EssayLinearRegression.js